import styled, { css } from "styled-components";

import { Paragraph } from "../typography/text";
import Icon from "../decorations/icons/icon";
import type { ExtractSCProps } from "pages/common/types/ExtractSCProps";

export type AlertType = "message" | "success" | "warn" | "error";

export const AlertInner = styled(Paragraph)<{
    floating?: boolean;
    borderless?: boolean;
    type?: AlertType;
    fontSize?: number;
}>`
    display: flex;
    align-items: center;
    border-radius: ${(props) => props.theme.borderRadius};
    border: 1px solid;
    padding: ${(props) => props.theme.padding}em;
    margin: 1em 0;
    overflow: auto;

    span {
        line-height: 1.5em;
        font-size: ${(props) => props.fontSize ?? props.theme.fontSize}px;
    }

    i {
        margin-right: 0.5em;
        font-size: 20px;
    }

    ${({ floating }) =>
        floating &&
        css`
            position: absolute;
            left: 15px;
            right: 15px;
            bottom: 60px;
            z-index: 1;
            text-align: center;
        `}

    ${({ type = `message` }) => {
        switch (type) {
            case `message`:
                return css`
                    border-color: #a9c9ff;
                    background: #dde9ff;
                    color: #719adf;
                `;
            case `success`:
                return css`
                    border-color: #8ceed6;
                    background: #e2f7f2;
                    color: #00ca98;
                `;
            case `warn`:
                return css`
                    border-color: #ffc461;
                    background: #fef5e5;
                    color: #f09d12;
                `;
            case `error`:
                return css`
                    border-color: #ffc0c8;
                    background: #ffe7ea;
                    color: #f25f6f;
                `;
        }
    }};

    ${({ borderless }) =>
        borderless &&
        css`
            background: none;
            border: 0;
        `}
    & a {
        color: inherit;
        text-decoration: underline;
    }
`;

const Alert = (
    props: ExtractSCProps<typeof AlertInner> & {
        icon?: string;
    }
) => {
    return (
        <AlertInner {...props}>
            {props.icon && <Icon name={props.icon} />}
            <span className="alert-inner-container">{props.children}</span>
        </AlertInner>
    );
};

const StyledAlert = styled(Alert)``;

export default StyledAlert;
